// src/constants/dealer.js
// homedepotshed.com is a single-dealer storefront for SE Yard Solutions (Edwin Miller).
// It rides on the shared ShedX Supabase database, so every PUBLIC storefront query
// must be scoped to Edwin's dealer row — otherwise test/junk rows belonging to other
// accounts in the shared database would leak onto the live site.
//
// This is the one and only dealer this storefront ever serves. Note that the
// SAME dealer row backs lowesheds.com, so dealer_id alone does not separate the
// two catalogs — see constants/brand.js for the discriminator that does.
export const DEALER_ID = 'de86ee69-4597-4f6e-b2da-3b430a3147c7';
